let decrementButton = document.querySelectorAll('.decrement');
let incrementButton = document.querySelectorAll('.increment');
let decrementButtonArray = Array.from(decrementButton);
let incrementButtonArray = Array.from(incrementButton);

decrementButtonArray.forEach( (item) => {
    item.addEventListener('click', (event) => {
       decrementQuantity(event.target);
    })
})
incrementButtonArray.forEach( (item) => {
    item.addEventListener('click', (event) => {
       incrementQuantity(event.target);
    })
})

function decrementQuantity(element){
    const input = element.closest('.quantity-selector').querySelector('#quantity');
    console.log(input.value)
    if (input.value > 1) {
        input.value = parseInt(input.value) - 1;
    }
}
function incrementQuantity(element){
    const input = element.closest('.quantity-selector').querySelector('#quantity');

    if (input.value < input.max ) {
        input.value = parseInt(input.value) + 1;
    }
}



